<template>
  <div
    class="list-item"
    :order-id="myOrder.id"
    :key="myOrder.id"
    v-if="!isDeleted"
  >
    <div class="order-type-tag-wrap" v-if="myOrder.activity_id == 41">
      >
      <div class="order-type-tag">
        咨询预沟通
      </div>
    </div>
    <v-touch class="item-top" @tap="localLinkToDetail(myOrder)">
      <img :src="myOrder.avatar" class="avatar" />

      <div class="order-details">
        <!--todo 使用 isFirstConsultationOrderGuidance和hideFirstConsultationOrderGuidance判断要不要显示红点 -->
        <div class="name">
          <span>
            {{ myOrder.name }}
          </span>
          <span
            class="new-icon new"
            v-if="role === 'teacher' && order.is_new === 1"
          >
            new
          </span>
          <span class="new-icon siren" v-if="order.is_offline === 1">
            私人
          </span>
        </div>
        <i class="icon-redDot" v-if="showFirstConsultRedDot"></i>
        <div class="type">
          <i :class="['yxlicon', getIconCls(myOrder.waytype)]"></i>
          <span class="type-name"
            >{{ myOrder.waytype }}{{ ` x ${myOrder.zx_num}` }}</span
          >
        </div>
        <div class="price">￥ {{ parseFloat(myOrder.fee) }}</div>
      </div>

      <div
        :class="[
          'status',
          'status-' + orderItemStatus[myOrder.process_status].class
        ]"
        v-html="orderItemStatus[myOrder.process_status].text"
      ></div>
    </v-touch>
    <template>
      <div class="opt-bar">
        <div class="created-time">{{ myOrder.created }}</div>
        <v-touch
          tag="div"
          class="opt-btn"
          @tap="linkToOrderHistory(myOrder.user_id)"
          v-if="
            myOrder.history === 1 &&
              (myOrder.process_status === 'waitPay' ||
                myOrder.process_status === 'waitAccept')
          "
          >咨询记录
        </v-touch>
        <!-- 订单已取消 -->

        <v-touch
          class="opt-btn"
          @tap="_deleteOrder()"
          v-if="myOrder.process_status === 'cancel'"
          >删除订单
        </v-touch>

        <!--4.17测试说不要了-->
        <v-touch
          class="opt-btn"
          @tap="localLinkToDetail(myOrder)"
          v-if="
            [
              'refund',
              'waitRefund',
              'cancel',
              'waitConsult',
              'complete',
              'waitRate',
              'waitComplete'
            ].indexOf(myOrder.process_status) !== -1
          "
          >查看详情
        </v-touch>

        <!-- 待来访者支付费用 -->
        <v-touch
          tag="div"
          :class="{
            'opt-btn': true,
            disabled: isCanNotEditPrice
          }"
          v-if="myOrder.process_status === 'waitPay'"
          @tap="changePrice"
        >
          {{ isCanNotEditPrice ? '不可改价' : '修改价格' }}
        </v-touch>

        <!-- 待处理 -->
        <template v-if="myOrder.process_status === 'waitAccept'">
          <!-- @麦子铭 #1261 待补充状态的订单，显示文案和按钮改回“待受理”和“受理咨询” -->
          <!-- <v-touch
            tag="span"
            v-if="order.is_uncomplete"
            class="opt-btn remind-btn"
            @tap="toChat(order.user_id)"
            >私信提醒
          </v-touch>
            v-else
           -->
          <v-touch
            tag="button"
            class="opt-btn accept-btn"
            @tap="_acceptReservation"
            >受理咨询
          </v-touch>
        </template>
        <!-- 待协商后进行咨询 -->
        <template v-if="myOrder.process_status === 'waitConsult'">
          <!-- <v-touch tag="button" class="opt-btn accept-btn" @tap=  "showConfirm({ orderId: myOrder.id })">确认完成</v-touch> -->
        </template>
        <!-- 待来访者确认完成 -->
        <template v-if="myOrder.process_status === 'waitComplete'">
          <v-touch
            tag="span"
            class="opt-btn remind-btn"
            @tap="remind(role === 'user', myOrder.id)"
            >提醒确认
          </v-touch>
        </template>
        <!-- 咨询已完成 -->
        <template v-if="order.process_status === 'waitRate'"></template>
        <!-- 预约失效 -->
        <template v-if="order.process_status === 'waitRefund'"></template>
        <!-- 预约失效 -->
        <template v-if="order.process_status === 'refund'"></template>

        <v-touch></v-touch>
      </div>
    </template>
  </div>
</template>

<script>
import bridgeMixin from '../../mixins/bridge'
import consultOrderMixin from '../../mixins/consultOrder'

export default {
  name: 'ConsultationOrderItem',
  mixins: [bridgeMixin, consultOrderMixin],

  props: {
    order: {
      type: Object,
      required: true
    },
    role: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isDeleted: false,
      myOrder: this.order,
      showFirstConsultRedDot: this.order.showFirstConsultRedDot
    }
  },
  computed: {
    isPreConsultOrder() {
      return Number(this.myOrder.activity_id) === 41
    },
    isCanNotEditPrice() {
      const { myOrder, order } = this
      return (
        Number(myOrder.original_price) === 0 ||
        myOrder.is_use_coupon !== 0 ||
        !!order.adviser_id ||
        this.isPreConsultOrder
      )
    },
    staticSite() {
      return location.protocol + '//' + location.host + location.pathname
    },
    orderItemStatus() {
      const { role } = this
      // return this.getProgressBarData(role === 'user', this.order.pay_status)[this.order.status]
      return role === 'user'
        ? {
            cancel: { class: 'failed', text: '已取消' },
            waitPay: { class: 'waiting', text: '待支付' },
            waitAccept: { class: 'waiting', text: '待咨询师确认' },
            waitConsult: { class: 'waiting', text: '待咨询' }, //待协商后进行咨询
            waitComplete: { class: 'waiting', text: '待确认完成' },
            waitRate: { class: 'waiting', text: '待评价' },
            complete: { class: 'complete', text: '已完成' },
            waitRefund: {
              class: 'waiting',
              text: `<span class='refund' style="color: #ccc;">预约失效</span> 退款中`
            },
            refund: {
              class: 'failed',
              text: `<span class='refund' style="color: #ccc;">预约失效</span> 已退款`
            }
          }
        : {
            cancel: { class: 'failed', text: '已取消' },
            waitPay: { class: 'waiting', text: '待来访者支付' },
            waitAccept: { class: 'waiting', text: '待受理' },
            waitConsult: { class: 'waiting', text: '待咨询' },
            waitComplete: { class: 'waiting', text: '待来访者确认' },
            waitRate: { class: 'complete', text: '已完成' }, //待评价
            // '5':  { class: 'waiting', text: '待评价'},
            complete: { class: 'complete', text: '已完成' },
            waitRefund: { class: 'failed', text: `退款中` },
            refund: { class: 'failed', text: `已退款` }
          }
    }
  },
  methods: {
    _deleteOrder() {
      this.$dialog({
        title: `删除订单后将无法恢复，是否确认删除该订单？`,
        theme: '#0B8BFF'
      }).then(() => {
        this.deleteOrder(this.order.id)
      })
    },
    changePrice() {
      // fix 点透
      setTimeout(() => {
        const { adviser_id } = this.order
        if (adviser_id) {
          this.$toast({ text: this.CANNOT_CHANGE_PRICE_TIPS })
          return
        }
        if (this.isPreConsultOrder) {
          this.$toast({ text: '该订单为预咨询沟通订单，不可修改价格' })
          return
        }
        if (this.isCanNotEditPrice) {
          this.$toast({
            text: '该订单已使用优惠，不支持修改价格'
          })
          return
        }
        this.$emit('slideShow', this.myOrder)
      }, 120)
    },
    _acceptReservation() {
      this.acceptReservation(this.myOrder).then(() => {
        // this.$emit('refresh')
        // this.myOrder.process_status = 3
        //切换到带咨询列表
        this.$emit('switchTab', 3)
      })
    },
    localLinkToDetail(myOrder) {
      if (this.showFirstConsultRedDot && this.platform.isYixinliApp) {
        this.showFirstConsultRedDot = false
        console.log('移除红点标记', this.showFirstConsultRedDot)

        this.getBridge().call('hideFirstConsultationOrderGuidance')
      }
      this.linkToDetail(this.role === 'user', myOrder.id)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/sass/config';
@import '../../assets/sass/function';
@import '../../assets/sass/mixin';

.list-item {
  width: pxToRem(702);
  margin: 0 auto pxToRem(12);
  background-color: #fff;
  border-radius: pxToRem(10);
  padding: pxToRem(24);
  box-sizing: border-box;
  position: relative;
  .item-top {
    display: flex;
    justify-content: space-between;
    .avatar {
      display: block;
      width: pxToRem(128);
      height: pxToRem(128);
      border-radius: pxToRem(8);
    }

    .order-details {
      flex: 1;
      margin-left: pxToRem(24);
      .name {
        color: #333;
        @include font-dpr(16px);
        line-height: pxToRem(45);
        display: flex;
        font-weight: bold;

        align-items: center;
        .new-icon {
          display: inline-block;
          width: pxToRem(68);
          height: pxToRem(30);
          text-align: center;
          line-height: pxToRem(30);
          margin-left: pxToRem(8);
          @include font-dpr(12px);
          border-radius: pxToRem(8);
          font-weight: normal;
          &.new {
            color: #ff8000;
            border: 1px solid #ff8000;
          }
          &.siren {
            color: #0b8bff;
            border: 1px solid #0b8bff;
          }
        }
      }

      .type {
        display: flex;
        line-height: pxToRem(36);
        margin-top: pxToRem(6);
        color: #666;
        .yxlicon {
          @include font-dpr(12px);
          color: #999;
        }
        .type-name {
          margin-left: pxToRem(12);
          @include font-dpr(13px);
        }
      }
      .price {
        @include font-dpr(15px);
        line-height: pxToRem(42);
        margin-top: pxToRem(10);
        color: #333;
      }
    }
    .status {
      @include font-dpr(13px);
      color: #0b8bff;
      line-height: pxToRem(36);
    }
  }

  .opt-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: pxToRem(36);
    .created-time {
      flex: 1;
      color: #999;
      @include font-dpr(12px);
      line-height: pxToRem(34);
    }
    .opt-btn {
      height: pxToRem(60);
      box-sizing: border-box;
      padding: 0 pxToRem(24);
      @include font-dpr(13px);
      border-radius: 20px;
      border: pxToRem(1) solid #ccc;
      line-height: pxToRem(60);
      color: #666;
      margin-left: pxToRem(24);
      &.accept-btn {
        color: #fff;
        background-image: linear-gradient(to right, #1abfff, #0b8bff);
      }
      &.disabled {
        background: #ccc;
        opacity: 0.6;
      }
      /*&.remind-btn {*/
      /*background-color: #fff;*/
      /*border: 1px solid #383838;*/
      /*color: #333;*/
      /*}*/
    }
  }

  .order-type-tag-wrap {
    height: pxToRem(28);
  }
  .order-type-tag {
    width: pxToRem(140);
    height: pxToRem(36);
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: pxToRem(22);
    color: #ffffff;
    line-height: 1.2;
    background: #ffa202;
    border-radius: 0px pxToRem(100) pxToRem(100) 0px;
    position: absolute;
    left: 0;
    top: pxToRem(10);
  }
}
</style>



// WEBPACK FOOTER //
// consultationOrderItem.vue?9db1bc22